export { default as PXTextModalWrapper } from './Layout';
